import APSeriesTable from './APSeriesTable';
import APTradesSeriesTable from './APTradesSeriesTable';

export {
  APSeriesTable, APTradesSeriesTable
};

export default APSeriesTable;
